/*

[Table of Contents]

1. BROWSER PROPERTIES
2. FUNCTIONS
	2.1 Console Errors Fix For Browsers Without Console
	2.2 Smart Resize
		2.2.1 Smart resize
		2.2.2 Debounce
	2.3 Smoothscroll for # links
	2.4 Tabs
	2.5 ASide Menu
	2.5 Truncate Text
	2.6 Header Transition
	2.7 Navigation Scroll (https://github.com/janpaepke/ScrollMagic)
	2.8 Fade-In Scroll (https://github.com/janpaepke/ScrollMagic)
	2.9 Get Post Nanme from Post Number
	2.10 Floorplan init
3. TRIGGERS
	3.1 Navigation Triggers
		3.1.1 Navigation Side Toggle
		3.1.2 Side/Mobile Submenu Triggers
		3.1.3 Primery Menu Submenu Triggers
		3.1.4 Search Fullscreen
		3.1.5 Location Change Fullscreen
	3.2 Navigation Footer
	3.3 Accordion
	3.4 Close Element
	3.5 Pagination [.pagination]
	3.6 Back to Top
	3.7 More Info Profile Toggle
	3.8 Select Opens Url
	3.8 Recipe Ingredients List
	3.9 Filter Toggles
	3.10 Input Post Number
	3.11 Amount Increase/Decrease Buttons
	3.12 Remove Product from Cart
	3.13 Collapsable Navigation
	3.14 Show More Toggle
4. WINDOW ON RESIZE
	4.1 Floorplan Init
5. WINDOW ON SCROLL
	5.1 Header Transition
6. DOCUMENT ON READY
	6.1 Slick Sliders (http://kenwheeler.github.io/slick/)
		6.1.1 Gallery
		6.1.2 Sliders
	6.2 Match Height
	6.3 Select2 (https://select2.org/)
	6.4 Navigation Scroll (https://github.com/janpaepke/ScrollMagic)
	6.5 Parallax Scrolling (https://github.com/mmkjony/enllax.js)
	6.6 Fade In https://github.com/janpaepke/ScrollMagic)
	6.7 Scrollable Tabs (jQuery UI + dragscroll + jquery.ui.touch-punch)
	6.8 NoUISlider (https://refreshless.com/nouislider/)
	6.9 Image Map Highlight (https://github.com/kemayo/maphilight)

*/


/*************** 1. BROWSER PROPERTIES ***************/

var doc = document.documentElement;
doc.setAttribute('data-useragent', navigator.userAgent);
var windowWidth = window.innerWidth;
var windowHeight = window.innerHeight;


/*************** 2. FUNCTIONS ***************/

/*****---------- 2.1 Console Errors Fix For Browsers Without Console ----------*****/

(function() {
    var method;
    var noop = function () {};
    var methods = [
        'assert', 'clear', 'count', 'debug', 'dir', 'dirxml', 'error',
        'exception', 'group', 'groupCollapsed', 'groupEnd', 'info', 'log',
        'markTimeline', 'profile', 'profileEnd', 'table', 'time', 'timeEnd',
        'timeline', 'timelineEnd', 'timeStamp', 'trace', 'warn'
    ];
    var length = methods.length;
    var console = (window.console = window.console || {});

    while (length--) {
        method = methods[length];

        // Only stub undefined methods.
        if (!console[method]) {
            console[method] = noop;
        }
    }
}());


/*****---------- 2.2 Smart Resize ----------*****/

/**------------- 2.2.1 Smart resize -------------**/

(function($,sr){
    var debounce = function (func, threshold, execAsap) {
        var timeout;

        return function debounced () {
            var obj = this, args = arguments;
            function delayed () {
                if (!execAsap)
                    func.apply(obj, args);
                timeout = null;
            };
            if (timeout)
                clearTimeout(timeout);
            else if (execAsap)
                func.apply(obj, args);
            timeout = setTimeout(delayed, threshold || 100);
        };
    }

    jQuery.fn[sr] = function(fn){  return fn ? this.bind('resize', debounce(fn)) : this.trigger(sr); };
})(jQuery,'smartresize');

/**------------- 2.2.2 Debounce -------------**/

function debounce(func, wait, immediate) {
    var timeout;
    return function() {
        var context = this, args = arguments;
        var later = function() {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
};


/*****---------- 2.3 Smoothscroll for # links ----------*****/
// function cloned to tus-custom.js, so it works for rendered elements

// $('a[href*="#"]').not('[href="#"]').not('[href="#0"]').click(function(event) {
//
//     var offset = 98;
//
//     if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
//         && location.hostname == this.hostname) {
//         var target = $(this.hash);
//         target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
//
//         if (target.length) {
//             event.preventDefault();
//
//             $('html, body').animate({
//                 scrollTop: target.offset().top - offset
//             }, 1000);
//         }
//     }
// });


/*****---------- 2.4 Tabs ----------*****/

function tabOnClick(element) {
    var elLink = element.parent().data('link');
    var elTabId = element.data('id');
    var expandable = false;
    var floorplan = false;

    if (element.hasClass('expandable')) {
        var expandable = true;
    }

    if (element.hasClass('floorplan')) {
        var floorplan = true;
    }

    if (expandable) {
        if (element.hasClass('expanded')) {
            element.removeClass('expanded').find('.subset').slideUp(200);
        } else {
            element.addClass('expanded').find('.subset').slideDown(200);
        }
    } else {
        element.siblings().removeClass('open');
        element.addClass('open');

        $('.js-tab-content[data-link="'+elLink+'"]').removeClass('open').hide();
        $('.js-tab-content[data-link="'+elLink+'"][data-id="'+elTabId+'"]').addClass('open').stop().fadeIn(500, function() {
            if (floorplan) {
                floorplanInit();
            }
        });
        //$('.js-tab-content[data-link="'+elLink+'"]').eq(elTabId-1).addClass('open').stop().fadeIn(1000);

        if (floorplan) {
            floorplanInit();
        }

        //if tab content has slider
        if (element.hasClass('js-has-slider')) {
            $('.js-tab-content[data-link="'+elLink+'"]').eq(elTabId-1).find('.custom-slick-slider').slick('setPosition');
        }

        //set select
        $('.js-custom-select-tabs[data-link="'+elLink+'"]').val(elTabId).trigger('change.select2');
    }
}

$('.js-subset li').click(function() {
    var el = $(this);
    var elParent = el.closest('.expandable')
    var elSubset = el.parent().data('subset');
    var elSubId = el.data('subid');
    var elText = el.text();
    var elTabId = elParent.data('id');
    var elLink = elParent.parent().data('link');

    //set tabs
    el.addClass('selected').siblings().removeClass('selected');
    elParent.siblings().removeClass('open');
    // elParent.addClass('open').find('.selected-option').text(elText);

    //set tab & subtab content
    $('.js-tab-content[data-link="'+elLink+'"]').removeClass('open').hide().eq(elTabId-1).addClass('open').stop().fadeIn(1000);
    $('.js-tab-content[data-link="'+elLink+'"]').eq(elTabId-1).find('.js-sub-tab-content').removeClass('open').hide().eq(elSubId-1).addClass('selected').stop().fadeIn(1000);

    //set select
    $('.js-custom-select-tabs[data-link="'+elLink+'"]').val(elSubset +'-'+ elSubId).trigger('change.select2');

    $('.custom-slick-slider').slick('reinit');

});

$('.js-tab').click(function() {
    tabOnClick($(this));
});

$('.js-custom-select-tabs').on('change', function() {
    var selectVal = this.value;
    var elLink = $(this).data('link');

    if ($('option:selected', this).attr('data-subset')) {
        //subtabs
        var elSubset = $('option:selected', this).data('subset');
        var elSubId = $('option:selected', this).data('subid');

        $('.js-tabs[data-link="'+elLink+'"] .subset[data-subset="'+elSubset+'"] li[data-subid="'+elSubId+'"]').trigger('click');
    } else {
        //tabs
        $('.js-tabs[data-link="'+elLink+'"] li[data-id="'+selectVal+'"]').trigger('click');
    }
});


/*****---------- 2.5 ASide Menu ----------*****/

function asideMenuOnClick(element) {
    element = element.parent();
    var elLink = element.parent().data('link');
    var elId = element.data('id');

    element.siblings().removeClass('open').find('.content').slideUp();
    element.addClass('open').find('.content').slideDown();

    $('.js-menu-aside-content[data-link="'+elLink+'"]').removeClass('open').hide();
    $('.js-menu-aside-content[data-link="'+elLink+'"]').eq(elId-1).addClass('open').stop().fadeIn(1000);

    //set select
    $('.js-custom-select-menu-aside[data-link="'+elLink+'"]').val(elId).trigger('change.select2');
}

$('.js-menu-aside li h4').click(function() {
    asideMenuOnClick($(this));
});

$('.js-custom-select-menu-aside').on('change', function() {
    var selectVal = this.value;
    var elLink = $(this).data('link');

    $('.js-menu-aside[data-link="'+elLink+'"] li[data-id="'+selectVal+'"] h4').trigger('click');
});


/*****---------- 2.5 Truncate Text ----------*****/

function truncateText(text, limit) {
    if (text.length > limit) {
        for (var i = limit; i > 0; i--) {
            if (text.charAt(i) === ' ' && (text.charAt(i-1) != ','||text.charAt(i-1) != '.'||text.charAt(i-1) != ';')) {
                return text.substring(0, i) + '...';
            }
        }
    } else {
        return text;
    }
};


/*****---------- 2.6 Header Transition ----------*****/

// function headerTransition() {
//     if ($(window).scrollTop() >= 10) {
//         $('.header, .main').addClass('tiny');
//     }
//     else {
//         $('.header, .main').removeClass('tiny');
//     }
// }


/*****---------- 2.7 Navigation Scroll (https://github.com/janpaepke/ScrollMagic) ----------*****/

function navigationScroll() {
    var controller = new ScrollMagic.Controller();
    var totalSections = $('.js-nav-scroll-section').length;

    for (i=1; i <= totalSections; i++) {
        new ScrollMagic.Scene({
            triggerElement: '#s' + i,
            duration: $('#s' + i).outerHeight()
        })
            .setClassToggle('.nav-s' + i, 'active')
            .addTo(controller)
            .on('progress', function(e) {
                $('.js-indicator').css('height',e.progress.toFixed(2)*100 + '%');
            });
    }
}

/*****---------- 2.8 Fade-In Scroll (https://github.com/janpaepke/ScrollMagic) ----------*****/

function fadeInScroll() {
    var controllerFadeIn = new ScrollMagic.Controller();

    $('.js-fade-in-item').each(function() {
        new ScrollMagic.Scene({
            triggerElement: $(this),
            duration: 0,
            triggerHook: 0.7
        })
            .setClassToggle($(this), 'active')
            .addTo(controllerFadeIn);
    });
}

/*****---------- 2.9 Get Post Nanme from Post Number ----------*****/

function getPostName(postNum) {
    var posts = {
        1000: 'Ljubljana',
        1001: 'Ljubljana',
        1210: 'Ljubljana - Šentvid',
        1211: 'Ljubljana - Šmartno',
        1215: 'Medvode',
        1216: 'Smlednik',
        1217: 'Vodice',
        1218: 'Komenda',
        1219: 'Laze v Tuhinju',
        1221: 'Motnik',
        1222: 'Trojane',
        1223: 'Blagovica',
        1225: 'Lukovica',
        1230: 'Domžale',
        1231: 'Ljubljana - Črnuče',
        1233: 'Dob',
        1234: 'Mengeš',
        1235: 'Radomlje',
        1236: 'Trzin',
        1241: 'Kamnik',
        1242: 'Stahovica',
        1251: 'Moravče',
        1252: 'Vače',
        1260: 'Ljubljana - Polje',
        1261: 'Ljubljana - Dobrunje',
        1262: 'Dol pri Ljubljani',
        1270: 'Litija',
        1272: 'Polšnik',
        1273: 'Dole pri Litiji',
        1274: 'Gabrovka',
        1275: 'Šmartno pri Litiji',
        1276: 'Primskovo',
        1281: 'Kresnice',
        1282: 'Sava',
        1290: 'Grosuplje',
        1291: 'Škofljica',
        1292: 'Ig',
        1293: 'Šmarje - Sap',
        1294: 'Višnja Gora',
        1295: 'Ivančna Gorica',
        1296: 'Šentvid pri Stični',
        1301: 'Krka',
        1303: 'Zagradec',
        1310: 'Ribnica',
        1311: 'Turjak',
        1312: 'Videm - Dobrepolje',
        1313: 'Struge',
        1314: 'Rob',
        1315: 'Velike Lašče',
        1316: 'Ortnek',
        1317: 'Sodražica',
        1318: 'Loški Potok',
        1319: 'Draga',
        1330: 'Kočevje',
        1331: 'Dolenja vas',
        1332: 'Stara Cerkev',
        1336: 'Kostel',
        1337: 'Osilnica',
        1338: 'Kočevska Reka',
        1351: 'Brezovica pri Ljubljani',
        1352: 'Preserje',
        1353: 'Borovnica',
        1354: 'Horjul',
        1355: 'Polhov Gradec',
        1356: 'Dobrova',
        1357: 'Notranje Gorice',
        1358: 'Log pri Brezovici',
        1360: 'Vrhnika',
        1370: 'Logatec',
        1372: 'Hotedršica',
        1373: 'Rovte',
        1380: 'Cerknica',
        1381: 'Rakek',
        1382: 'Begunje pri Cerknici',
        1384: 'Grahovo',
        1385: 'Nova vas',
        1386: 'Stari trg pri Ložu',
        1410: 'Zagorje ob Savi',
        1411: 'Izlake',
        1412: 'Kisovec',
        1413: 'Čemšenik',
        1414: 'Podkum',
        1420: 'Trbovlje',
        1423: 'Dobovec',
        1430: 'Hrastnik',
        1431: 'Dol pri Hrastniku',
        1432: 'Zidani Most',
        1433: 'Radeče',
        1434: 'Loka pri Zidanem Mostu',
        1501: 'Ljubljana',
        1502: 'Ljubljana',
        1503: 'Ljubljana',
        1505: 'Ljubljana',
        1506: 'Ljubljana',
        1509: 'Ljubljana',
        1516: 'Ljubljana',
        1519: 'Ljubljana',
        1524: 'Ljubljana',
        1525: 'Ljubljana',
        1528: 'Ljubljana',
        1533: 'Ljubljana',
        1534: 'Ljubljana',
        1535: 'Ljubljana',
        1544: 'Ljubljana',
        1547: 'Ljubljana',
        1550: 'Ljubljana',
        1600: 'Ljubljana',
        2000: 'Maribor',
        2001: 'Maribor',
        2002: 'Maribor - poštni center',
        2201: 'Zgornja Kungota',
        2204: 'Miklavž na Dravskem polju',
        2205: 'Starše',
        2206: 'Marjeta na Dravskem polju',
        2208: 'Pohorje',
        2211: 'Pesnica pri Mariboru',
        2212: 'Šentilj v Slovenskih goricah',
        2213: 'Zgornja Velka',
        2214: 'Sladki vrh',
        2215: 'Ceršak',
        2221: 'Jarenina',
        2222: 'Jakobski Dol',
        2223: 'Jurovski Dol',
        2229: 'Malečnik',
        2230: 'Lenart v Slovenskih goricah',
        2231: 'Pernica',
        2232: 'Voličina',
        2233: 'Sveta Ana v Slovenskih goricah',
        2234: 'Benedikt',
        2235: 'Sveta Trojica v Slovenskih goricah',
        2236: 'Cerkvenjak',
        2241: 'Spodnji Duplek',
        2242: 'Zgornja Korena',
        2250: 'Ptuj',
        2252: 'Dornava',
        2253: 'Destrnik',
        2254: 'Trnovska vas',
        2255: 'Vitomarci',
        2256: 'Juršinci',
        2257: 'Polenšak',
        2258: 'Sveti Tomaž',
        2259: 'Ivanjkovci',
        2270: 'Ormož',
        2272: 'Gorišnica',
        2273: 'Podgorci',
        2274: 'Velika Nedelja',
        2275: 'Miklavž pri Ormožu',
        2276: 'Kog',
        2277: 'Središče ob Dravi',
        2281: 'Markovci',
        2282: 'Cirkulane',
        2283: 'Zavrč',
        2284: 'Videm pri Ptuju',
        2285: 'Zgornji Leskovec',
        2286: 'Podlehnik',
        2287: 'Žetale',
        2288: 'Hajdina',
        2289: 'Stoperce',
        2310: 'Slovenska Bistrica',
        2311: 'Hoče',
        2312: 'Orehova vas',
        2313: 'Fram',
        2314: 'Zgornja Polskava',
        2315: 'Šmartno na Pohorju',
        2316: 'Zgornja Ložnica',
        2317: 'Oplotnica',
        2318: 'Laporje',
        2319: 'Poljčane',
        2321: 'Makole',
        2322: 'Majšperk',
        2323: 'Ptujska Gora',
        2324: 'Lovrenc na Dravskem polju',
        2325: 'Kidričevo',
        2326: 'Cirkovce',
        2327: 'Rače',
        2331: 'Pragersko',
        2341: 'Limbuš',
        2342: 'Ruše',
        2343: 'Fala',
        2344: 'Lovrenc na Pohorju',
        2345: 'Bistrica ob Dravi',
        2351: 'Kamnica',
        2352: 'Selnica ob Dravi',
        2353: 'Sv. Duh na Ostrem Vrhu',
        2354: 'Bresternica',
        2360: 'Radlje ob Dravi',
        2361: 'Ožbalt',
        2362: 'Kapla',
        2363: 'Podvelka',
        2364: 'Ribnica na Pohorju',
        2365: 'Vuhred',
        2366: 'Muta',
        2367: 'Vuzenica',
        2370: 'Dravograd',
        2371: 'Trbonje',
        2372: 'Libeliče',
        2373: 'Šentjanž pri Dravogradu',
        2380: 'Slovenj Gradec',
        2381: 'Podgorje pri Slovenj Gradcu',
        2382: 'Mislinja',
        2383: 'Šmartno pri Slovenj Gradcu',
        2390: 'Ravne na Koroškem',
        2391: 'Prevalje',
        2392: 'Mežica',
        2393: 'Črna na Koroškem',
        2394: 'Kotlje',
        2500: 'Maribor',
        2501: 'Maribor',
        2502: 'Maribor',
        2503: 'Maribor',
        2505: 'Maribor',
        2507: 'Maribor',
        2508: 'Maribor',
        2509: 'Maribor',
        2600: 'Maribor',
        2603: 'Maribor',
        3000: 'Celje',
        3001: 'Celje',
        3201: 'Šmartno v Rožni dolini',
        3202: 'Ljubečna',
        3203: 'Nova Cerkev',
        3204: 'Dobrna',
        3205: 'Vitanje',
        3206: 'Stranice',
        3210: 'Slovenske Konjice',
        3211: 'Škofja vas',
        3212: 'Vojnik',
        3213: 'Frankolovo',
        3214: 'Zreče',
        3215: 'Loče',
        3220: 'Štore',
        3221: 'Teharje',
        3222: 'Dramlje',
        3223: 'Loka pri Žusmu',
        3224: 'Dobje pri Planini',
        3225: 'Planina pri Sevnici',
        3230: 'Šentjur',
        3231: 'Grobelno',
        3232: 'Ponikva',
        3233: 'Kalobje',
        3240: 'Šmarje pri Jelšah',
        3241: 'Podplat',
        3250: 'Rogaška Slatina',
        3252: 'Rogatec',
        3253: 'Pristava pri Mestinju',
        3254: 'Podčetrtek',
        3255: 'Buče',
        3256: 'Bistrica ob Sotli',
        3257: 'Podsreda',
        3260: 'Kozje',
        3261: 'Lesično',
        3262: 'Prevorje',
        3263: 'Gorica pri Slivnici',
        3264: 'Sveti Štefan',
        3270: 'Laško',
        3271: 'Šentrupert',
        3272: 'Rimske Toplice',
        3273: 'Jurklošter',
        3301: 'Petrovče',
        3302: 'Griže',
        3303: 'Gomilsko',
        3304: 'Tabor',
        3305: 'Vransko',
        3310: 'Žalec',
        3311: 'Šempeter v Savinjski dolini',
        3312: 'Prebold',
        3313: 'Polzela',
        3314: 'Braslovče',
        3320: 'Velenje',
        3322: 'Velenje',
        3325: 'Šoštanj',
        3326: 'Topolšica',
        3327: 'Šmartno ob Paki',
        3330: 'Mozirje',
        3331: 'Nazarje',
        3332: 'Rečica ob Savinji',
        3333: 'Ljubno ob Savinji',
        3334: 'Luče',
        3335: 'Solčava',
        3341: 'Šmartno ob Dreti',
        3342: 'Gornji Grad',
        3503: 'Velenje',
        3600: 'Celje',
        4000: 'Kranj',
        4001: 'Kranj',
        4200: 'Kranj',
        4201: 'Zgornja Besnica',
        4202: 'Naklo',
        4203: 'Duplje',
        4204: 'Golnik',
        4205: 'Preddvor',
        4206: 'Zgornje Jezersko',
        4207: 'Cerklje na Gorenjskem',
        4208: 'Šenčur',
        4209: 'Žabnica',
        4210: 'Brnik - aerodrom',
        4211: 'Mavčiče',
        4212: 'Visoko',
        4220: 'Škofja Loka',
        4223: 'Poljane nad Škofjo Loko',
        4224: 'Gorenja vas',
        4225: 'Sovodenj',
        4226: 'Žiri',
        4227: 'Selca',
        4228: 'Železniki',
        4229: 'Sorica',
        4240: 'Radovljica',
        4243: 'Brezje',
        4244: 'Podnart',
        4245: 'Kropa',
        4246: 'Kamna Gorica',
        4247: 'Zgornje Gorje',
        4248: 'Lesce',
        4260: 'Bled',
        4263: 'Bohinjska Bela',
        4264: 'Bohinjska Bistrica',
        4265: 'Bohinjsko jezero',
        4267: 'Srednja vas v Bohinju',
        4270: 'Jesenice',
        4273: 'Blejska Dobrava',
        4274: 'Žirovnica',
        4275: 'Begunje na Gorenjskem',
        4276: 'Hrušica',
        4280: 'Kranjska Gora',
        4281: 'Mojstrana',
        4282: 'Gozd Martuljek',
        4283: 'Rateče - Planica',
        4290: 'Tržič',
        4294: 'Križe',
        4502: 'Kranj',
        4600: 'Kranj',
        5000: 'Nova Gorica',
        5001: 'Nova Gorica',
        5210: 'Deskle',
        5211: 'Kojsko',
        5212: 'Dobrovo v Brdih',
        5213: 'Kanal',
        5214: 'Kal nad Kanalom',
        5215: 'Ročinj',
        5216: 'Most na Soči',
        5220: 'Tolmin',
        5222: 'Kobarid',
        5223: 'Breginj',
        5224: 'Srpenica',
        5230: 'Bovec',
        5231: 'Log pod Mangartom',
        5232: 'Soča',
        5242: 'Grahovo ob Bači',
        5243: 'Podbrdo',
        5250: 'Solkan',
        5251: 'Grgar',
        5252: 'Trnovo pri Gorici',
        5253: 'Čepovan',
        5261: 'Šempas',
        5262: 'Črniče',
        5263: 'Dobravlje',
        5270: 'Ajdovščina',
        5271: 'Vipava',
        5272: 'Podnanos',
        5273: 'Col',
        5274: 'Črni Vrh nad Idrijo',
        5275: 'Godovič',
        5280: 'Idrija',
        5281: 'Spodnja Idrija',
        5282: 'Cerkno',
        5283: 'Slap ob Idrijci',
        5290: 'Šempeter pri Gorici',
        5291: 'Miren',
        5292: 'Renče',
        5293: 'Volčja Draga',
        5294: 'Dornberk',
        5295: 'Branik',
        5296: 'Kostanjevica na Krasu',
        5297: 'Prvačina',
        5600: 'Nova Gorica',
        6000: 'Koper - Capodistria',
        6001: 'Koper - Capodistria',
        6200: 'Koper - Capodistria',
        6210: 'Sežana',
        6215: 'Divača',
        6216: 'Podgorje',
        6217: 'Vremski Britof',
        6219: 'Lokev',
        6221: 'Dutovlje',
        6222: 'Štanjel',
        6223: 'Komen',
        6224: 'Senožeče',
        6225: 'Hruševje',
        6230: 'Postojna',
        6232: 'Planina',
        6240: 'Kozina',
        6242: 'Materija',
        6243: 'Obrov',
        6244: 'Podgrad',
        6250: 'Ilirska Bistrica',
        6253: 'Knežak',
        6254: 'Jelšane',
        6255: 'Prem',
        6256: 'Košana',
        6257: 'Pivka',
        6258: 'Prestranek',
        6271: 'Dekani',
        6272: 'Gračišče',
        6273: 'Marezige',
        6274: 'Šmarje',
        6275: 'Črni Kal',
        6276: 'Pobegi',
        6280: 'Ankaran - Ancarano',
        6281: 'Škofije',
        6310: 'Izola - Isola',
        6320: 'Portorož - Portorose',
        6330: 'Piran - Pirano',
        6333: 'Sečovlje - Sicciole',
        6501: 'Koper - Capodistria',
        6502: 'Koper - Capodistria',
        6503: 'Koper - Capodistria',
        6504: 'Koper - Capodistria',
        6600: 'Koper - Capodistria',
        8000: 'Novo mesto',
        8001: 'Novo mesto',
        8210: 'Trebnje',
        8211: 'Dobrnič',
        8212: 'Velika Loka',
        8213: 'Veliki Gaber',
        8216: 'Mirna Peč',
        8220: 'Šmarješke Toplice',
        8222: 'Otočec',
        8230: 'Mokronog',
        8231: 'Trebelno',
        8232: 'Šentrupert',
        8233: 'Mirna',
        8250: 'Brežice',
        8251: 'Čatež ob Savi',
        8253: 'Artiče',
        8254: 'Globoko',
        8255: 'Pišece',
        8256: 'Sromlje',
        8257: 'Dobova',
        8258: 'Kapele',
        8259: 'Bizeljsko',
        8261: 'Jesenice na Dolenjskem',
        8262: 'Krška vas',
        8263: 'Cerklje ob Krki',
        8270: 'Krško',
        8272: 'Zdole',
        8273: 'Leskovec pri Krškem',
        8274: 'Raka',
        8275: 'Škocjan',
        8276: 'Bučka',
        8280: 'Brestanica',
        8281: 'Senovo',
        8282: 'Koprivnica',
        8283: 'Blanca',
        8290: 'Sevnica',
        8292: 'Zabukovje',
        8293: 'Studenec',
        8294: 'Boštanj',
        8295: 'Tržišče',
        8296: 'Krmelj',
        8297: 'Šentjanž',
        8310: 'Šentjernej',
        8311: 'Kostanjevica na Krki',
        8312: 'Podbočje',
        8321: 'Brusnice',
        8322: 'Stopiče',
        8323: 'Uršna sela',
        8330: 'Metlika',
        8331: 'Suhor',
        8332: 'Gradac',
        8333: 'Semič',
        8340: 'Črnomelj',
        8341: 'Adlešiči',
        8342: 'Stari trg ob Kolpi',
        8343: 'Dragatuš',
        8344: 'Vinica',
        8350: 'Dolenjske Toplice',
        8351: 'Straža',
        8360: 'Žužemberk',
        8361: 'Dvor',
        8362: 'Hinje',
        8501: 'Novo mesto',
        8600: 'Nova mesto',
        9000: 'Murska Sobota',
        9001: 'Murska Sobota',
        9201: 'Puconci',
        9202: 'Mačkovci',
        9203: 'Petrovci',
        9204: 'Šalovci',
        9205: 'Hodoš - Hodos',
        9206: 'Križevci',
        9207: 'Prosenjakovci - Partosfalva',
        9208: 'Fokovci',
        9220: 'Lendava - Lendva',
        9221: 'Martjanci',
        9222: 'Bogojina',
        9223: 'Dobrovnik - Dobronak',
        9224: 'Turnišče',
        9225: 'Velika Polana',
        9226: 'Moravske Toplice',
        9227: 'Kobilje',
        9231: 'Beltinci',
        9232: 'Črenšovci',
        9233: 'Odranci',
        9240: 'Ljutomer',
        9241: 'Veržej',
        9242: 'Križevci pri Ljutomeru',
        9243: 'Mala Nedelja',
        9244: 'Sveti Jurij ob Ščavnici',
        9245: 'Spodnji Ivanjci',
        9246: 'Razkrižje',
        9250: 'Gornja Radgona',
        9251: 'Tišina',
        9252: 'Radenci',
        9253: 'Apače',
        9261: 'Cankova',
        9262: 'Rogašovci',
        9263: 'Kuzma',
        9264: 'Grad',
        9265: 'Bodonci',
        9501: 'Murska Sobota',
        9502: 'Radenci',
        9600: 'Murska Sobota'
    };

    if (postNum in posts) {
        return posts[postNum];
    } else {
        return '';
    }
}

/*****---------- 2.10 Floorplan init ----------*****/

function floorplanInit() {
    $('map').imageMapResize();
    $('.js-image-map-resize').maphilight({
        strokeColor: '000',
        fill: false,
        strokeWidth: 2
    });
}


/*************** 3. TRIGGERS ***************/


/*****---------- 3.1 Navigation Triggers ----------*****/


/**------------- 3.1.1 Navigation Side Toggle -------------**/

$('.js-navigation-side-toggle').click(function() {
    if ($(this).hasClass('open')) {
        $('.navigation-side').removeClass('open');
        $('.js-navigation-side-toggle').removeClass('open');
        $('body').removeClass('darken');
        //$('html, body').removeClass('overflow');
        $('.header').removeClass('open-menu');
    } else {
        $('.js-navigation-side-toggle').addClass('open');
        $('body').addClass('darken');
        //$('html, body').addClass('overflow');
        $('.header').addClass('open-menu');
        $('.navigation-side').addClass('open');
    }
});

//close side navigation on click outside header
$(document).mouseup(function(e) {
    var container = $('.header');

    // if the target of the click isn't the container nor a descendant of the container
    if (!container.is(e.target) && container.has(e.target).length === 0) {
        $('.navigation-side').removeClass('open');
        $('.js-navigation-side-toggle').removeClass('open');
        $('body').removeClass('darken');
        $('.header').removeClass('open-menu');
    }
});


/**------------- 3.1.2 Side/Mobile Submenu Triggers -------------**/

$('.menu .has-children .icon-angle-right').click(function(e) {
    e.preventDefault();
    var el = $(this).closest('li');

    if (el.hasClass('open')) {
        el.removeClass('open');
      $('.blog-menu').removeClass('display-none');
    } else {
        el.addClass('open');
      $('.blog-menu').addClass('display-none');
    }
});

$('.js-btn-submenu-back').click(function(e) {
    e.preventDefault();
    $(this).closest('.has-children').removeClass('open');
    $('.blog-menu').removeClass('display-none');
});

/**------------- 3.1.3 Primery Menu Submenu Triggers -------------**/

/*$('.navigation-primary .has-children > a').click(function(e) {
	e.preventDefault();
	var el = $(this).parent();

	if (!el.hasClass('open')) {
		$('.navigation-primary li').removeClass('open').find('.submenu').slideUp();
		el.addClass('open');
		el.find('.submenu').slideDown();
	} else {
		el.removeClass('open');
		el.find('.submenu').slideUp();
	}
});*/

/**------------- 3.1.4 Search Fullscreen -------------**/

$('.js-fullscreen-search-toggle').click(function(e) {
    e.preventDefault();

    if (!$(this).hasClass('open')) {
        $('.js-fullscreen-search').addClass('open');
        $('.js-fullscreen-search input[type="text"]').focus();
        $('.js-fullscreen-search-toggle').addClass('open');
    }
});

$('.js-fullscreen-search .js-btn-close').click(function(e) {
    e.preventDefault();

    $('.js-fullscreen-search').removeClass('open');
    $('.js-fullscreen-search-toggle').removeClass('open');
});

$('.js-section-fullscreen-billsea .js-btn-close').click(function(e) {
    e.preventDefault();

    $('.section-fullscreen-billsea').removeClass('open');
});

/**------------- 3.1.5 Location Change Fullscreen -------------**/

/*$('.js-fullscreen-location-change-toggle').click(function(e) {
	e.preventDefault();

	if (!$(this).hasClass('open')) {
		$('.js-fullscreen-location-change').addClass('open');
		$('.js-fullscreen-location-change-toggle').addClass('open');
	}
});*/

$('.js-fullscreen-location-change .js-btn-close').click(function(e) {
    e.preventDefault();

    $('.js-fullscreen-location-change').removeClass('open');
    $('.js-fullscreen-location-change-toggle').removeClass('open');
});

$('.js-change-location li').click(function(e) {
    e.preventDefault();
    var el = $(this);
    var elClass = el.data('class');
    var elLocation = el.data('location');

    if (!el.hasClass('active')) {
        el.siblings().removeClass('active');
        el.addClass('active');
        $('.location-planet .pin').removeClass('celje kranj maribor novo-mesto koper ljubljana-btc').addClass(elClass);
        $('.js-location-change-text').text(elLocation);
    }
});

$('.js-fullscreen-newsletter .js-btn-close').click(function(e) {
  e.preventDefault();

  $('.js-fullscreen-newsletter').removeClass('open');
  $('.js-fullscreen-newsletter-toggle').removeClass('open');
});

$('.js-btn-submit-location-change').click(function(e) {
    e.preventDefault();

    $('.js-fullscreen-location-change').removeClass('open');
    $('.js-fullscreen-location-change-toggle').removeClass('open');
});



/*****---------- 3.2 Navigation Footer ----------*****/

$('.js-navigation-footer .js-toggle').click(function() {
    windowWidth = window.innerWidth;
    var el = $(this);

    if (windowWidth < 768) {
        if (el.hasClass('open')) {
            el.parent().find('>ul').stop().slideUp(300);
            el.removeClass('open');
        } else {
            el.parent().find('>ul').stop().slideDown(300);
            el.addClass('open');
        }
    }
});


/*****---------- 3.3 Accordion ----------*****/

$('.js-accordion-toggle').click(function(e) {
    e.preventDefault();
    var el = $(this);
    var elContent = el.closest('.js-accordion').find('.js-accordion-content');
    windowWidth = window.innerWidth;

    if (el.hasClass('js-mobile-only') && windowWidth >= 768) {
        return false;
    }

    if (el.hasClass('open')) {
        elContent.stop().slideUp(300);
        el.removeClass('open');
    } else {
        elContent.stop().slideDown(300);
        el.addClass('open');
    }
});


/*****---------- 3.4 Close Element ----------*****/

$('.js-close').click(function(e) {
    e.preventDefault();
    var elTarget = $(this).closest('.js-close-target');

    elTarget.slideUp(300, function() {
        if (elTarget != 'slide') {
            $(this).remove();
        }
    });
});


/*****---------- 3.5 Pagination [.pagination] ----------*****/

$('.js-pagination a').click(function(e, index) {
    e.preventDefault();
    var el = $(this);
    var elFirst = $(this).parent().find('.js-pagination-first');
    var elLast = $(this).parent().find('.js-pagination-last');
    var elPrev =  $(this).parent().find('.js-pagination-prev');
    var elNext =  $(this).parent().find('.js-pagination-next');
    var index = $(this).data('index');
    var totalItems = $(this).parent().find('a:last-child').data('index');
    var elActive = $(this).parent().find('.active').data('index');

    //set select
    $('.js-custom-select-pagination').val(index).trigger('change.select2');

    //set active page
    el.siblings('a').removeClass('active disabled');

    //prev or next
    if (el.hasClass('js-pagination-prev')) {
        if (elActive == 2) {
            elPrev.addClass('disabled');
        }
        if (elActive > 1) {
            el.parent().find('a[data-index="'+(elActive-1)+'"]').not('.js-pagination-first').addClass('active');
            $('.js-custom-select-pagination').val(elActive-1).trigger('change.select2');
            return false;
        }
    } else if (el.hasClass('js-pagination-next')) {
        if (elActive == totalItems-1) {
            elNext.addClass('disabled');
        }
        if (elActive < totalItems) {
            el.parent().find('a[data-index="'+(elActive+1)+'"]').not('.js-pagination-last').addClass('active');
            $('.js-custom-select-pagination').val(elActive+1).trigger('change.select2');
            return false;
        }
    }

    if (index == 1) {
        elFirst.addClass('disabled');
        elPrev.addClass('disabled');
        el.parent().find('a[data-index="'+index+'"]').not('.js-pagination-first').addClass('active');
    } else if (index == totalItems) {
        elLast.addClass('disabled');
        elNext.addClass('disabled');
        el.parent().find('a[data-index="'+index+'"]').not('.js-pagination-last').addClass('active');
    } else {
        el.parent().find('a[data-index="'+index+'"]').addClass('active');
    }
});

$('.js-custom-select-pagination').on('change', function() {
    var selectVal = this.value;

    $(this).closest('.pagination').find('a[data-index="'+selectVal+'"]').trigger('click');
});


/*****---------- 3.6 Back to Top ----------*****/

$('.js-back-to-top').click(function(e) {
    e.preventDefault();
    $('html, body').animate({
        scrollTop: 0
    }, 1500);
});

/*****---------- 3.7 More Info Profile Toggle ----------*****/

$('.js-btn-more-info-toggle').click(function(e) {
    e.preventDefault();
    var el = $(this);
    var elContent = $(this).parent().find('.js-more-info-content');

    if (el.hasClass('open')) {
        elContent.stop().slideUp(300);
        el.removeClass('open');
    } else {
        elContent.stop().slideDown(300);
        el.addClass('open');
    }
});

/*****---------- 3.8 Select Opens Url ----------*****/

$('.js-filter-search-toggle').click(function(e) {
    e.preventDefault();
    var el = $(this);

    if (el.hasClass('open')) {
        el.removeClass('open');
        $('.js-accordion-filter-search').stop().slideUp();
    } else {
        el.addClass('open');
        $('.js-accordion-filter-search').stop().slideDown();
        $('.js-accordion-filter-sort').stop().slideUp();
        $('.js-filter-sort-toggle').removeClass('open');
    }
});

$('.js-filter-sort-toggle').click(function(e) {
    e.preventDefault();
    var el = $(this);

    if (el.hasClass('open')) {
        el.removeClass('open');
        $('.js-accordion-filter-sort').stop().slideUp();
    } else {
        el.addClass('open');
        $('.js-accordion-filter-sort').stop().slideDown();
        $('.js-accordion-filter-search').stop().slideUp();
        $('.js-filter-search-toggle').removeClass('open');
    }
});

$('.js-filter-extra-toggle').click(function(e) {
    e.preventDefault();
    var el = $(this);

    if (el.hasClass('open')) {
        el.removeClass('open');
        $('.js-filter-extra').removeClass('open');

    } else {
        el.addClass('open');
        $('.js-filter-extra').addClass('open');
    }
});

$('.js-filter-extra .js-btn-close').click(function(e) {
    e.preventDefault();

    $('.js-filter-extra-toggle, .js-filter-extra').removeClass('open');
});


/*****---------- 3.8 Recipe Ingredients List ----------*****/

$('.js-recipe-ingredients-list li').click(function(e) {
    e.preventDefault();
    var el = $(this);

    addItemsToShoppingList([{'name':el.text()}]);
});

$('.js-btn-recipe-ingredients-list-all').click(function(e) {
    e.preventDefault();

    var items = [];

    var els = $('.list-recipe-ingredients').find('li');
    els.each(function() {
        items.push({'name': $(this).text()});
    });

    addItemsToShoppingList(items, els);
});

function applyListAddListeners() {
    $(".add-to-list").on('click', function (e) {
        e.preventDefault();
        var ean = jQuery(this).parents('.card').data('product-ean');

        //add ean to redirect get parameter
        if (jQuery('a.login-overlay').length) {
            var href = jQuery('a.login-overlay').attr('href'); //get current href url
            var parameters = getUrlParams(href); //get parameters from url
            parameters['product-ean'] = ean; //set new ean
            var url = href.slice(0, href.indexOf('?') + 1) + jQuery.param(parameters); //build new url
            jQuery('a.login-overlay').attr('href', url); //set new redirect url
        }

        addItemsToShoppingList([{'ean': ean }]);
    });

    $(".mini-cart-add-to-list").on('click', function (e) {
        e.preventDefault();
        var ean = jQuery(this).parents('li.woocommerce-mini-cart-item').data('product-ean');

        addItemsToShoppingList([{'ean': ean}]);
    });

    $(".single-add-to-list").on('click', function (e) {
        e.preventDefault();
        var ean = jQuery(this).data('product-ean');
        var quantity = $('.qty').val();

        addItemsToShoppingList([{'ean': ean, 'quantity': quantity}]);
    });


    $('.js-fullscreen-shopping-list-change #create-list').unbind().on('click', function(e) {
        e.preventDefault();

        var listName = jQuery('#list-name').val();
        if (!listName) {
            return;
        }
    });
}

applyListAddListeners();

$('.js-fullscreen-shopping-list-change .js-btn-close').click(function(e) {
    e.preventDefault();

    $('.js-fullscreen-shopping-list-change').removeClass('open');
});

function applyM10ActivateListener() {
    $('.m10-activate').on('click', function(e) {
        e.preventDefault();

        var cardEl = $(this).parents('.card');
        var ean = cardEl.data('product-ean');
        if(typeof ean === 'undefined') {
            ean = $(this).data('product-ean');
        }

        $('.js-fullscreen-m10-confirm').addClass('open');
        $(".activateProduct").show();
        $('.productAddToM10').hide();
        $('.productM10Joker').hide();

        $('.js-fullscreen-m10-confirm .btn').click(function(e) {

            if ($(this).data('confirm') == 'no') {
                $('.js-fullscreen-m10-confirm').removeClass('open');
                $('.js-fullscreen-m10-confirm .btn').off('click');
                $('.js-fullscreen-m10-confirm .btn').unbind('click');
                return;
            }


            jQuery.ajax({
                type: "POST",
                url: ajax_object.ajaxurl,
                data: {
                    action: 'tk_activate_m10',
                    async: true,
                    ean: ean
                },
                success: function (response) {
                    response = $.parseJSON(response);
                    if (!response.error) {
                        cardEl.addClass('checked');
                        cardEl.find('.m10-activate').hide();
                        $(".activateProduct").hide();
                        $('.productAddToM10').fadeIn();
                        // if (response.count === 10) {
                        //   $('.productM10Joker').show();
                        // } else {
                          setTimeout(
                            function () {
                              $('.js-fullscreen-m10-confirm').removeClass('open');
                            }, 2000
                          );
                        // }
                        $('.section-my-10-products .m10-'+response.type+' ul.grid').append(response.html);
                        tusM10SetCounter();
                        renderTusMojih10TemplateCopy();
                    } else {
                        if (response.msg === '10 activated') {
                            $('.productM10Full').show();
                            $('.productM10Joker').remove();
                            $('.activateProduct').remove();
                        }
                    }
                }
            });
        });
    });
}

function tusM10SetCounter() {
  jQuery.ajax({
    type: "POST",
    url: ajax_object.ajaxurl,
    data: {
      action: 'm10_set_counter'
    },
    success: function (response) {
      response = $.parseJSON(response);
      if (jQuery('#number-products-trgovina').length) {
        jQuery('#number-products-trgovina').text(response.m10 + '/10)');
      }
      if (jQuery('#number-products-drogerija').length) {
        jQuery('#number-products-drogerija').text(response.m10d + '/10)');
      }
      // if (jQuery('#m10-counter-here').length) {
      //   jQuery('#m10-counter-here').text(response.m10 + '/10)');
      // }
      // if (jQuery('#m10-counter-here-d').length) {
      //   jQuery('#m10-counter-here-d').text(response.m10d + '/10)');
      // }
    }
  });
}

/**
 * Copied from tus-public.js
 */
function renderTusMojih10TemplateCopy() {
  jQuery.ajax({
    url: ajax_object.ajaxurl,
    type: 'POST',
    data: {
      'action': 'template_tus_mojih_10'
    },
    success: function (response) {
      var data = $.parseJSON(response);
      if (jQuery(".section-my-10-products-activated").length) {
        jQuery(".section-my-10-products-activated").find(".article").html(data.html);
      }
    }
  });
}

applyM10ActivateListener();

$('.js-fullscreen-m10-confirm .js-btn-close').click(function(e) {
    e.preventDefault();

    $('.js-fullscreen-m10-confirm').removeClass('open');
});

function addItemsToShoppingList(items, elements) {
    $('.js-fullscreen-shopping-list-change').addClass('open');
    $(".form-fullscreen-shopping-list-change").show();
    $('.productAddToList').hide();

    $('.js-btn-submit-shopping-list-change').click(function(e) {
        e.preventDefault();

        var val = $(this).parents('form').find('select').val();
        if (!val) {
            return false;
        }

        $(".form-fullscreen-shopping-list-change").hide();
        $('.productAddToList').fadeIn();
        setTimeout(
            function()
            {
                $('.js-fullscreen-shopping-list-change').removeClass('open');
            }, 2000);


        jQuery.ajax({
            type: "POST",
            url: ajax_object.ajaxurl,
            data: {
                action: 'tk_list_add_items',
                async: true,
                listId: $(this).parents('form').find('select').val(),
                items: items
            },
            success: function (response) {
                res = $.parseJSON(response);
                if (!res.error) {
                    if (elements.length) {
                        elements.each(function() {
                            $(this).toggleClass('on-shopping-list');
                        });
                    }
                } else {

                }
            }
        });
    });
}

$("#tusNewsletter").submit(function(e) {
    e.preventDefault();

    var form = $(this);

    $.ajax({
        type: "POST",
        url: ajax_object.ajaxurl,
        data: {
            action: 'tus_newsletter_subscription',
            async: true,
            form_data: form.serialize()
        },
        success: function (response) {
            response = $.parseJSON(response);
            console.log('response', response);
            if (!response.error) {
                form.find('.form-row').replaceWith('<p>Na vpisani e-naslov je bilo poslano sporočilo s potrditveno povezavo.</p>');
            } else {
                form.find('.form-row').replaceWith('<p>Prišlo je do napake, poskusite kasneje.</p>');
            }
        }
    });
});

/*****---------- 3.9 Filter Toggles ----------*****/

$('.js-filter-select-url').change(function() {
    window.location = $(this).val();
});


/*****---------- 3.10 Input Post Number ----------*****/

$('.js-input-post').on('input', function() {
    var elVal = $(this).val();
    $(this).parent().find('.js-input-post-text').text(getPostName(elVal));
});

/*****---------- 3.11 Amount Increase/Decrease Buttons ----------*****/

$('.js-amount-interact').click(function(e) {
    e.preventDefault();
    var el = $(this);
    var elInput = $(this).parent().find('.js-order-amount');
    var elInputVal = elInput.val();

    if (el.hasClass('js-amount-plus') && elInputVal <= 999) {
        elInputVal++
    } else if (el.hasClass('js-amount-minus') && elInputVal > 1) {
        elInputVal--
    }

    elInput.val(elInputVal);
});

/*****---------- 3.12 Remove Product from Cart ----------*****/

$('.js-remove-product').click(function(e) {
    var el = $(this);
    var elParent = el.closest('tr');

    elParent.remove();
});

/*****---------- 3.13 Collapsable Navigation ----------*****/

$('.js-collapsable-navigation li.has-children h4').click(function() {
    console.log('coll clicked', $(this));

    var el = $(this);
    var elParent = el.parent();
    var submenu = elParent.find('.submenu');

    $(this).parent().siblings().not($(this)).removeClass('open');
    $(this).parent().siblings().not($(this)).find('.submenu').css('display', 'none');

    submenu.stop().slideToggle(200).closest('.has-children').toggleClass('open');
});

$('.js-collapsable-navigation li.has-children h5').click(function() {
    var el = $(this);
    var elParent = el.parent();
    var submenu = elParent.find('.sub-submenu');

    submenu.stop().slideToggle(200).closest('.has-children').toggleClass('open');
});

/*****---------- 3.14 Show More Toggle ----------*****/

$('.js-show-more-toggle').click(function() {
    var el = $(this);
    var defaultTxt = el.attr('data-closed');
    var openTxt = el.attr('data-open');

    el.toggleClass('open').parent().find('.js-show-more-content').stop().slideToggle(200);

    if (el.hasClass('open')) {
        el.text(openTxt);
    } else {
        el.text(defaultTxt);
    }
});

/*****---------- 3.15 Floorplan ----------*****/

function getAreaCenter(shape, coords) {
    var coordsArray = coords.split(','),
        center = [];
    if (shape == 'circle') {
        // For circle areas the center is given by the first two values
        center = [coordsArray[0], coordsArray[1]];
    } else {
        // For rect and poly areas we need to loop through the coordinates
        var coord,
            minX = maxX = parseInt(coordsArray[0], 10),
            minY = maxY = parseInt(coordsArray[1], 10);
        for (var i = 0, l = coordsArray.length; i < l; i++) {
            coord = parseInt(coordsArray[i], 10);
            if (i%2 == 0) { // Even values are X coordinates
                if (coord < minX) {
                    minX = coord;
                } else if (coord > maxX) {
                    maxX = coord;
                }
            } else { // Odd values are Y coordinates
                if (coord < minY) {
                    minY = coord;
                } else if (coord > maxY) {
                    maxY = coord;
                }
            }
        }
        center = [parseInt((minX + maxX) / 2, 10), parseInt((minY + maxY) / 2, 10)];
    }
    return(center);
}

function highlighArea(elID) {

    var el = $('#'+elID);
    var data = el.data('maphilight') || {};

    data.alwaysOn = !data.alwaysOn;
    $(el).siblings().data('maphilight', '');
    $(el).data('maphilight', data).trigger('alwaysOn.maphilight');
}

function showFloorplanPopup(e, element, centerPos) {

    var el = element;
    var elID = el.attr('id');
    var elShape = el.attr('shape');
    var elCoords = el.attr('coords');
    var elLink = el.parent().data('link');
    var elLength = $('.js-collapsable-navigation-floorplan[data-link="'+elLink+'"] .submenu li[data-id="'+elID+'"] .floorplan-shop-details').length;
    var elHref = $('.js-collapsable-navigation-floorplan[data-link="'+elLink+'"] .submenu li[data-id="'+elID+'"] .floorplan-shop-details .content a').attr('href');
    var contentH5 = $('.js-collapsable-navigation-floorplan[data-link="'+elLink+'"] .submenu li[data-id="'+elID+'"] .floorplan-shop-details h5').html();
    var contentImg = $('.js-collapsable-navigation-floorplan[data-link="'+elLink+'"] .submenu li[data-id="'+elID+'"] .floorplan-shop-details .shop-logo')[0];
    var contentShortDesc = $('.js-collapsable-navigation-floorplan[data-link="'+elLink+'"] .submenu li[data-id="'+elID+'"] .floorplan-shop-details .shop-description').html();
    var parentOffset = el.closest('.floorplan').offset();
    var elHtml;

    var flipOffset = 360;

    if (centerPos) {
        flipOffset -= 40;
    }


    if(contentImg) {
        elHtml =
            '<div class="floorplan-popup js-floorplan-popup">' +
            '<a href="' + elHref + '">' +
            '<div class="floorplan-shop-details">' +
            '<img src="' + contentImg.attributes[0].value + '" alt="' + contentImg.alt + '" class="shop-logo">' +
            '<div class="content">' +
            '<h5>' + contentH5 + '</h5>' +
            '<p class="shop-description">' +
            contentShortDesc +
            '</p>' +
            '</div>' +
            '</div>' +
            '</a>' +
            '</div>';
    } else {
        elHtml =
            '<div class="floorplan-popup js-floorplan-popup">' +
            '<a href="' + elHref + '">' +
            '<div class="floorplan-shop-details">' +
            '<div class="content">' +
            '<h5>' + contentH5 + '</h5>' +
            '<p class="shop-description">' +
            contentShortDesc +
            '</p>' +
            '</div>' +
            '</div>' +
            '</a>' +
            '</div>';
    }

    if(elLength) {

        //insert shop html
        $('.js-floorplan-parent-popup').html(elHtml);

        var relX;
        var relY;

        if (!centerPos) {
            relX = e.pageX - parentOffset.left;
            relY = e.pageY - parentOffset.top - ($('.js-floorplan-popup').height() / 2 + 20 - $('.section-floorplan .article').height());
        } else {
            var areaCenter = getAreaCenter(elShape, elCoords);
            relX = areaCenter[0];
            relY = areaCenter[1] - ($('.js-floorplan-popup').height() / 2 + 20 - $('.section-floorplan .article').height());

        }


        //flip popup
        if (relX > flipOffset) {
            relX = relX - flipOffset;
            if(!centerPos) {
                relX = relX + 30;
            } else {
                relX = relX - 30;
            }

            $('.js-floorplan-popup').addClass('flip');
        } else {
            relX = relX + 30;
            $('.js-floorplan-popup').removeClass('flip');
        }

        //show popup
        $('.js-floorplan-popup').css({top: relY, left: relX}).show();

        // close open navigation
        // $('.js-collapsable-navigation-floorplan li').removeClass('open');
        // $('.js-collapsable-navigation-floorplan li > .submenu').css('display', 'none');

        if (!centerPos) {
            floorplanNavigation(e, $('.js-collapsable-navigation-floorplan[data-link="' + elLink + '"] .submenu li[data-id="' + elID + '"]'), false);
        }

    }
}

function floorplanNavigation(e, element, openPopup) {
    var el = element;
    var elNavigation = el.closest('.js-collapsable-navigation-floorplan');
    var elNavigationID = elNavigation.data('link');
    var elID = el.data('id');
    var elShop = el.find('.floorplan-shop-details');
    var shopHTML = '<div class="floorplan-shop-details">' + elShop.html() + '</div>';

    e.preventDefault();

    //check if parent menu is open (for clicks on map)
    if (!el.closest('.has-children').hasClass('open')) {
        el.closest('.has-children').find('h4').trigger('click');
    }

    if (!el.hasClass('open')) {
        elNavigation.find('.submenu .open .floorplan-shop-details').stop().slideUp();
        elNavigation.find('.submenu .open').removeClass('open');
        el.addClass('open');
        elShop.stop().slideDown();

        //show shop-details for mobile
        $('.mobile-floorplan-shop-details-wrapper[data-link="'+elNavigationID+'"]').html(shopHTML);

        //set select
        $('.js-custom-select-floorplan[data-link="'+elNavigationID+'"]').val(elID).trigger('change.select2');

        //open popup
        if (openPopup) {
            showFloorplanPopup(e, $('map[data-link="'+elNavigationID+'"] area#'+elID), true);
        }

    } else {
        el.removeClass('open');
        elShop.stop().slideUp();

        //hide popup
        $('.js-floorplan-popup').hide();

        //hide shop-details for mobile
        $('.mobile-floorplan-shop-details-wrapper[data-link="'+elNavigationID+'"]').html('');

        //set select to placeholder
        $('.js-custom-select-floorplan[data-link="'+elNavigationID+'"]').val('').trigger('change.select2');
    }

    highlighArea(elID);
}

$('area').on('click', function(e) {

    e.preventDefault();

    showFloorplanPopup(e, $(this), false);

    //open navigation
    // var elID = this_el.attr('id');
    // var elLink = this_el.parent().data('link');
    // var navEl = $('li[data-id=' + elID +  ']');
    // console.log(navEl);
    //
    // openFloorplanNav(navEl, e);


    // $('.js-collapsable-navigation-floorplan[data-link="'+elLink+'"] .submenu li[data-id="'+elID+'"]').trigger('click');
});

$('.js-floorplan-popup').on('click', function(e) {
    $(this).hide();
});

$('.js-collapsable-navigation-floorplan .submenu li').click(function(e) {

    // var el = $(this);
    //
    // var elID = el.data('id');
    //
    // openFloorplanNav(el, e);
    //
    // //highlight shop
    // highlighArea(elID);
    //
    // var map_element = $('#' + elID);
    //
    // var element_type = 'nav';
    //
    // showFloorplanPopup(map_element, e, element_type);
    e.preventDefault();
    floorplanNavigation(e, $(this), true);
});


//select trigger click
$('.js-custom-select-floorplan').on('change', function() {
    var selectVal = this.value;
    var elLink = $(this).data('link');

    $('.js-collapsable-navigation-floorplan[data-link="'+elLink+'"] .submenu li[data-id="'+selectVal+'"]').trigger('click');
});

// close popup on floor change
$('.js-tab-floorplan').click(function () {
    $('.js-floorplan-popup').hide();
});


/*************** 4. WINDOW ON RESIZE ***************/

$(window).smartresize(function() {
    //windowWidth = window.innerWidth;

    /*****---------- 4.1 Floorplan Init ----------*****/
    if ($('.js-image-map-resize').length) {
        floorplanInit();
    }
});


/*************** 5. WINDOW ON SCROLL ***************/

$(window).scroll(function() {

    /*****---------- 5.1 Header Transition ----------*****/
    // headerTransition();

});


/*************** 6. DOCUMENT ON READY ***************/

$(document).ready(function() {

    /*****---------- 6.1 Slick Sliders (http://kenwheeler.github.io/slick/) ----------*****/

    /**------------- 6.1.1 Gallery -------------**/

        //set slick options
    var slickGallery = {
            mobileFirst: true,
            dots: false,
            arrows: false,
            autoplay: false,
            speed: 300,
            infinite: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            fade: true,
            centerMode: true,
            zIndex: 1,
        };

    var slickGalleryNav = {
        mobileFirst: true,
        dots: false,
        arrows: true,
        autoplay: false,
        speed: 300,
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: false,
        zIndex: 1,
        variableWidth: true,
        //focusOnSelect: true,
        responsive: [
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 3,
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 4,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 5,
                }
            }
        ]
    };

    //init sliders
    if ($('.js-gallery').length) {
        $gallery = $('.js-gallery').slick(slickGallery).fadeIn(1500);
    }
    if ($('.js-gallery-nav').length) {
        $galleryNav = $('.js-gallery-nav').slick(slickGalleryNav).fadeIn(1500);
    }

    //gallery interaction
    $('.js-gallery-nav .slick-slide').click(function() {
        var id = $(this).attr('data-slick-index');

        $('.js-gallery').slick('slickGoTo', id);
        $('.js-gallery-nav .slick-slide').removeClass('slick-current-custom');
        $('.js-gallery-nav .slick-slide[data-slick-index='+id+']').addClass('slick-current-custom');
    });

    $('.js-gallery').on('afterChange', function(event, slick, currentSlide, nextSlide){
        $('.js-gallery-nav .slick-slide').removeClass('slick-current-custom');
        $('.js-gallery-nav .slick-slide[data-slick-index='+currentSlide+']').addClass('slick-current-custom');
    });

    /**------------- 6.1.2 Sliders -------------**/

        //set slick options
    var slickMax2 = {
        mobileFirst: true,
        dots: false,
        arrows: true,
        autoplay: false,
        speed: 300,
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        zIndex: 1,
        responsive: [
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 2,
            }
          }
        ]
      };

    var slickMax3 = {
            mobileFirst: true,
            dots: false,
            arrows: true,
            autoplay: false,
            speed: 300,
            infinite: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            zIndex: 1,
            responsive: [
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        centerMode: false,
                        slidesToShow: 3,
                    }
                }
            ]
        };

    var slickMax4 = {
        mobileFirst: true,
        dots: false,
        arrows: true,
        autoplay: false,
        speed: 300,
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        zIndex: 1,
        responsive: [
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    centerMode: false,
                    slidesToShow: 3,
                }
            },
            {
                breakpoint: 1024,
                settings: {
                    centerMode: false,
                    slidesToShow: 4,
                }
            }
        ]
    };

    var slickMax4Specials = {
        mobileFirst: true,
        dots: false,
        arrows: true,
        autoplay: false,
        speed: 300,
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        zIndex: 1,
        responsive: [
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                }
            },
            {
                breakpoint: 700,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 1024,
                settings: {
                    centerMode: false,
                    slidesToShow: 3,
                }
            },
            {
                breakpoint: 1200,
                settings: {
                    centerMode: false,
                    slidesToShow: 4,
                }
            }
        ]
    };

    var slickMax4Less2 = {
        mobileFirst: true,
        dots: false,
        arrows: true,
        autoplay: false,
        speed: 300,
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        zIndex: 1,
        responsive: [
            {
                breakpoint: 200,
                settings: {
                    slidesToShow: 2,
                }
            },

            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 700,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 1024,
                settings: {
                    centerMode: false,
                    slidesToShow: 3,
                }
            },
            {
                breakpoint: 1200,
                settings: {
                    centerMode: false,
                    slidesToShow: 4,
                }
            }
        ]
    };

    var slickMax5 = {
        mobileFirst: true,
        dots: false,
        arrows: true,
        autoplay: false,
        speed: 300,
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        zIndex: 1,
        responsive: [
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    centerMode: false,
                    slidesToShow: 3,
                }
            },
            {
                breakpoint: 1024,
                settings: {
                    centerMode: false,
                    slidesToShow: 5,
                }
            }
        ]
    };

    var slickHero = {
        mobileFirst: true,
        dots: true,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 5000,
        speed: 800,
        infinite: true,
        fade: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        zIndex: 1
    };

    var slickMax6 = {
        mobileFirst: true,
        dots: false,
        arrows: true,
        autoplay: false,
        speed: 300,
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        zIndex: 1,
        responsive: [
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    centerMode: false,
                    slidesToShow: 3,
                }
            },
            {
                breakpoint: 880,
                settings: {
                    centerMode: false,
                    slidesToShow: 4,
                }
            },
            {
                breakpoint: 1024,
                settings: {
                    centerMode: false,
                    slidesToShow: 5,
                }
            },
            {
                breakpoint: 1200,
                settings: {
                    centerMode: false,
                    slidesToShow: 6,
                }
            }
        ]
    };

    //init sliders
    if ($('.js-slick-slider').length) {
        $('.js-slick-slider[data-show-max-slides="2"]').slick(slickMax2).fadeIn(1500);
        $('.js-slick-slider[data-show-max-slides="3"]').slick(slickMax3).fadeIn(1500);
        $('.js-slick-slider[data-show-max-slides="4"]').slick(slickMax4).fadeIn(1500);
        $('.js-slick-slider[data-show-max-slides="4-specials"]').slick(slickMax4Specials).fadeIn(1500);
        $('.js-slick-slider[data-show-max-slides="5"]').slick(slickMax5).fadeIn(1500);
        $('.js-slick-slider[data-show-max-slides="6"]').slick(slickMax6).fadeIn(1500);
        $('.js-slick-slider[data-show-max-slides="hero"]').slick(slickHero).fadeIn(1500);
        $('.js-slick-slider[data-show-max-slides="4-less2"]').slick(slickMax4Less2).fadeIn(1500);
    }

    if($('.instagram-pics').length) {
        $('.vce-widgets-container .instagram-pics').slick(slickMax4).fadeIn(1500);
    }

    /*****---------- 6.2 Match Height ----------*****/

    if ($('.js-match-height').length) {
        $('.js-match-height').matchHeight({remove: false, byRow: false});
    }

    if ($(window).width() < 480) {
        $('.js-match-height').matchHeight({ remove: true });
    }

    /*****---------- 6.3 Select2 (https://select2.org/) ----------*****/

        //set select2 options
    var customSelectOptions = {
            // theme: 'tus',
            minimumResultsForSearch: -1,
            width: '100%'
        };

    if(jQuery('#select2-tus-container').length) {
        customSelectOptions = {
            // theme: 'tus',
            minimumResultsForSearch: -1,
            width: '100%',
            dropdownParent:jQuery('#select2-tus-container')
        }
    }

    //init select2
    if ($('.js-custom-select').length) {
        $('.js-custom-select').select2(customSelectOptions);
    }

    /*****---------- 6.4 Navigation Scroll (https://github.com/janpaepke/ScrollMagic) ----------*****/

    if ($('body.js-navigation-scroll').length) {
        setTimeout(navigationScroll, 500);
    }

    /*****---------- 6.6 Fade In https://github.com/janpaepke/ScrollMagic) ----------*****/

    if ($('.js-fade-in-sequence').length) {
        setTimeout(fadeInScroll, 500);
    }

    /*****---------- 6.7 Scrollable Tabs (jQuery UI + dragscroll + jquery.ui.touch-punch) ----------*****/

    if ($('.tabs.dragonscroll').length) {
        if (windowWidth >= 768) {
            $('.tabs.lite').slider();
        }
    }

    /*****---------- 6.8 NoUISlider (https://refreshless.com/nouislider/) ----------*****/

    if ($('.js-range-slider').length) {
        var rangeSlider = document.getElementById('price-range-slider');
        var nodes = [
            document.getElementById('start-price'),
            document.getElementById('end-price')
        ];

        noUiSlider.create(rangeSlider, {
            start: [ 0, 1200 ],
            connect: true,
            range: {
                'min': 0,
                'max': 1200
            }
        });

        rangeSlider.noUiSlider.on('update', function(values, handle) {
            var value = values[handle];
            nodes[handle].value = Math.ceil(values[handle]);
        });

        $('.js-range-start').change(function() {
            rangeSlider.noUiSlider.set([this.value, null]);
        });

        $('.js-range-end').change(function() {
            rangeSlider.noUiSlider.set([null, this.value]);
        });
    }


    /*****---------- 6.9 Image Map Highlight (https://github.com/kemayo/maphilight) ----------*****/

    if ($('.js-image-map-resize').length) {
        floorplanInit();
    }

    //Create mobile menu
    if (jQuery(".vce-basic-menu-wrapper").length) {
        createMobileMenu('.vce-basic-menu-wrapper');
        $('.vce-basic-menu-wrapper select').on('change', function() {
            window.location.href = $(this).find(":selected").val();
        });

        $(".vce-basic-menu-wrapper select").val(window.location.href);
    }
    if ($('.rsTmb').length > 0) {
      $('.rsTmb').removeClass('lazyloading');
    }
});

$(window).on('load', function(){
    /*****---------- 6.5 Parallax Scrolling (https://github.com/mmkjony/enllax.js) ----------*****/

    if ($('.js-parallax').length) {
        $(window).enllax();
    }

    if($('body').find('.custom-slick-slider').length) {
      setTimeout(function(){jQuery(window).trigger('resize')}, 0);
    }
});


if ( $(window).width() <= 768) {

  $( "#my-10-btn" ).click(function() {
    document.getElementById("my-10-btn").style.bottom = "-250px";
    document.getElementById("my-10-popup").style.bottom = "60px";
  });
  $( "#close-10-sidebar" ).click(function() {
    document.getElementById("my-10-btn").style.bottom = "60px";
    document.getElementById("my-10-popup").style.bottom = "-250px";
  });

}else {
  $( "#my-10-btn" ).click(function() {
    document.getElementById("my-10-btn").style.right = "-50px";
    document.getElementById("my-10-popup").style.right = "0";
  });
  $( "#close-10-sidebar" ).click(function() {
    document.getElementById("my-10-btn").style.right = "0";
    document.getElementById("my-10-popup").style.right = "-250px";
  });
}

if($(".btn-sticky").length > 0) {
  var distance = $('.btn-sticky').offset().top;

  $(window).scroll(function () {

    if ($(window).scrollTop() >= distance) {
      $('.btn-sticky').addClass("stick");

    } else {
      $('.btn-sticky').removeClass("stick");
    }
  });
}



/*end f62744 mobile sticky btn*/
if($(".filter-products").length > 0) {
  var distancef = $('.filter-products').offset().top;
  $(window).scroll(function () {

    if ($(window).scrollTop() >= distancef) {
      $(".filter-products").addClass("stickyFilter");
      $(".form-filter.form-filter-my-10-products").addClass("stickForm");

    } else {
      $(".filter-products").removeClass("stickyFilter");
      $(".form-filter.form-filter-my-10-products").removeClass("stickForm");
    }
  });
}

function createMobileMenu(element)
{
    var $element = $(element);
    var select = $("<select class='vce-mobile-menu-select-mobile' />");
    var option;
    $element.find("li.menu-item").each(function() {
        var a_element = $(this).find('a');

        if($(this).hasClass('current-menu-item')) {
            option = $("<option />",
                {
                    "value": a_element.attr("href"),
                    "text": a_element.text(),
                    "selected": 'selected'
                });
        } else {
            option = $("<option />",
                {
                    "value": a_element.attr("href"),
                    "text": a_element.text()
                });
        }


        if (a_element.hasClass('active'))
        {
            option.addClass('active').prependTo(select);
        }
        else
        {
            option.appendTo(select);
        }
    });

    $element.append(select);

    // var customSelectOptions = {
    //     // theme: 'tus',
    //     // minimumResultsForSearch: Infinity
    //     minimumResultsForSearch: -1
    // };

    // $('.vce-mobile-menu-select-new').select2(customSelectOptions);
    // $('.vce-mobile-menu-select').select2();
}


/**
 * Reorder product_cat_m10 categories in Woof
 */
function sortM10Categories() {
    var catUl = jQuery('body').find('.woof_container_product_cat_m10 ul.woof_list');
    var catLis = catUl.find('li');

    catLis.sort(function(a, b) {
        var orderA = jQuery(a).find('span.m10_term_order').data('order'),
            orderB = jQuery(b).find('span.m10_term_order').data('order');

        return orderA > orderB;
    }).appendTo(catUl);
}

/**
 * JavaScript Get URL Parameter
 *
 * @param String url The url
 * @param String prop The specific URL parameter you want to retreive the value for
 * @return String|Object If prop is provided a string value is returned, otherwise an object of all properties is returned
 */
function getUrlParams( url, prop ) {
    var params = {};
    var search = decodeURIComponent( url.slice( url.indexOf( '?' ) + 1 ) );
    var definitions = search.split( '&' );

    definitions.forEach( function( val, key ) {
        var parts = val.split( '=', 2 );
        params[ parts[ 0 ] ] = parts[ 1 ];
    } );

    return ( prop && prop in params ) ? params[ prop ] : params;
}
